import { Text, Title } from "@clipboard-health/ui-components";
import { Link, Stack } from "@mui/material";
import { Li, Ul } from "@src/appV2/lib/Lists";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";

import { useSkillsAssessmentFeatureFlags } from "../../api/useSkillsAssessmentFeatureFlags";

export function SkillsAssessmentStatusUnderReviewScheduled() {
  const { skillsAssessmentConfig } = useSkillsAssessmentFeatureFlags();
  const { openArticle } = useZendeskArticle();

  return (
    <Stack spacing={4}>
      <Title component="h1">We&apos;re reviewing the video assessment you completed.</Title>
      <Ul>
        <Li>
          <Text sx={{ lineHeight: "24px" }}>
            We&apos;ll let you know the results within 1 business day. If you passed the assessment
            you&apos;ll be able to book shifts at that time.
          </Text>
        </Li>
        <Li>
          <Text sx={{ lineHeight: "24px" }}>
            Tap{" "}
            <Link
              onClick={async () => {
                await openArticle(skillsAssessmentConfig.supportArticleLink);
              }}
            >
              here
            </Link>{" "}
            to view additional details about the assessment.
          </Text>
        </Li>
      </Ul>
    </Stack>
  );
}
